
import Conf from '../../configuration'

export default {


    is: {

        ipad: () => getUserAgent().IS_IPAD,

        iphone: () => getUserAgent().IS_IPHONE,

        ios: () => getUserAgent().IS_IOS,

        android: () => getUserAgent().IS_ANDROID,

        mobile: () => getUserAgent().IS_MOBILE

    },

    getDevice: getDevice

}

function getUserAgent () {
    const IS_IPAD = navigator.userAgent.match(/iPad/i) !== null
    const IS_IPHONE = !IS_IPAD && ((navigator.userAgent.match(/iPhone/i) !== null) || (navigator.userAgent.match(/iPod/i) !== null))
    const IS_IOS = IS_IPAD || IS_IPHONE
    const IS_ANDROID = !IS_IOS && navigator.userAgent.match(/android/i) !== null
    const IS_MOBILE = IS_IOS || IS_ANDROID || window.screen.width < 569
    return {
        IS_IPAD,
        IS_IPHONE,
        IS_IOS,
        IS_ANDROID,
        IS_MOBILE
    }
}

function getDevice () {

    return `web-${window.innerWidth < Conf.size.tablet ? 'mobile' : 'desktop'}`
}
